// extracted by mini-css-extract-plugin
module.exports = {"button":"Styles_button__S6TzQ"};